import HTTPService from '../HTTPService'

class Groups {
  getAll (companySlug) {
    return HTTPService.get(`company/${companySlug}/group`)
  }

  addOne (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/group`, {
      name: payload.name,
      description: payload.description
    })
  }

  getOne (companySlug, groupSlug) {
    return HTTPService.get(`company/${companySlug}/group/${groupSlug}`)
  }

  updateOne (companySlug, groupSlug, payload) {
    return HTTPService.put(`company/${companySlug}/group/${groupSlug}`, {
      name: payload.name,
      description: payload.description,
      permissions: payload.permissions
    })
  }

  deleteOne (companySlug, groupSlug) {
    return HTTPService.delete(`company/${companySlug}/group/${groupSlug}`)
  }

  getMembers (companySlug, groupSlug) {
    return HTTPService.get(`company/${companySlug}/group/${groupSlug}/member`)
  }

  addMembers (companySlug, groupSlug, payload) {
    return HTTPService.post(`company/${companySlug}/group/${groupSlug}/member`, {
      emails: payload.emails
    })
  }

  removeMembers (companySlug, groupSlug, payload) {
    return HTTPService.delete(`company/${companySlug}/group/${groupSlug}/member`, {
      emails: payload.emails
    })
  }
}

export default new Groups()
